import React from 'react';
import { Box, Skeleton, Stack } from '@mui/material';

export const LoadingPublications = () => {
    return (
        <>
            <div className='preview-desktop' >
                <Box
                    sx={{
                        display: 'flex',
                        width: '100%',
                        border: '1px solid rgba(0,0,0,0.15)',
                        borderRadius: 2,
                        overflow: 'hidden',
                        bgcolor: '#fff',
                        boxShadow: 1,
                    }}
                >
                    {/* Parte izquierda: avatar + texto */}
                    <Box
                        sx={{
                            width: '50%',
                            p: 2,
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'space-between',
                        }}
                    >
                        {/* Header avatar + nombre */}
                        <Stack direction="row" spacing={2} alignItems="center" mb={2}>
                            <Skeleton variant="circular" width={48} height={48} />
                            <Box sx={{ flexGrow: 1 }}>
                                <Skeleton variant="text" width="80%" height={20} />
                                <Skeleton variant="text" width="60%" height={15} sx={{ mt: 0.5 }} />
                            </Box>
                        </Stack>

                        {/* Texto principal (mensaje) */}
                        <Skeleton variant="rectangular" width="100%" height={300} sx={{ mb: 2, borderRadius: 1 }} />

                        {/* Barra inferior con iconos y texto */}
                        <Stack direction="row" spacing={1} alignItems="center">
                            <Skeleton variant="circular" width={40} height={40} />
                            <Skeleton variant="text" width={100} height={20} />
                            <Box sx={{ flexGrow: 1 }} />
                            <Skeleton variant="circular" width={40} height={40} />
                        </Stack>
                    </Box>

                    {/* Parte derecha: imagen */}
                    <Skeleton variant="rectangular" width="50%" sx={{ height: 'auto' }} />
                </Box>
                <br></br>
                <Box
                    sx={{
                        display: 'flex',
                        width: '100%',
                        border: '1px solid rgba(0,0,0,0.15)',
                        borderRadius: 2,
                        overflow: 'hidden',
                        bgcolor: '#fff',
                        boxShadow: 1,
                    }}
                >
                    {/* Parte izquierda: avatar + texto */}
                    <Box
                        sx={{
                            width: '50%',
                            p: 2,
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'space-between',
                        }}
                    >
                        {/* Header avatar + nombre */}
                        <Stack direction="row" spacing={2} alignItems="center" mb={2}>
                            <Skeleton variant="circular" width={48} height={48} />
                            <Box sx={{ flexGrow: 1 }}>
                                <Skeleton variant="text" width="80%" height={20} />
                                <Skeleton variant="text" width="60%" height={15} sx={{ mt: 0.5 }} />
                            </Box>
                        </Stack>

                        {/* Texto principal (mensaje) */}
                        <Skeleton variant="rectangular" width="100%" height={300} sx={{ mb: 2, borderRadius: 1 }} />

                        {/* Barra inferior con iconos y texto */}
                        <Stack direction="row" spacing={1} alignItems="center">
                            <Skeleton variant="circular" width={40} height={40} />
                            <Skeleton variant="text" width={100} height={20} />
                            <Box sx={{ flexGrow: 1 }} />
                            <Skeleton variant="circular" width={40} height={40} />
                        </Stack>
                    </Box>

                    {/* Parte derecha: imagen */}
                    <Skeleton variant="rectangular" width="50%" sx={{ height: 'auto' }} />
                </Box>
                <br></br>
                <Box
                    sx={{
                        display: 'flex',
                        width: '100%',
                        border: '1px solid rgba(0,0,0,0.15)',
                        borderRadius: 2,
                        overflow: 'hidden',
                        bgcolor: '#fff',
                        boxShadow: 1,
                    }}
                >
                    {/* Parte izquierda: avatar + texto */}
                    <Box
                        sx={{
                            width: '50%',
                            p: 2,
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'space-between',
                        }}
                    >
                        {/* Header avatar + nombre */}
                        <Stack direction="row" spacing={2} alignItems="center" mb={2}>
                            <Skeleton variant="circular" width={48} height={48} />
                            <Box sx={{ flexGrow: 1 }}>
                                <Skeleton variant="text" width="80%" height={20} />
                                <Skeleton variant="text" width="60%" height={15} sx={{ mt: 0.5 }} />
                            </Box>
                        </Stack>

                        {/* Texto principal (mensaje) */}
                        <Skeleton variant="rectangular" width="100%" height={300} sx={{ mb: 2, borderRadius: 1 }} />

                        {/* Barra inferior con iconos y texto */}
                        <Stack direction="row" spacing={1} alignItems="center">
                            <Skeleton variant="circular" width={40} height={40} />
                            <Skeleton variant="text" width={100} height={20} />
                            <Box sx={{ flexGrow: 1 }} />
                            <Skeleton variant="circular" width={40} height={40} />
                        </Stack>
                    </Box>

                    {/* Parte derecha: imagen */}
                    <Skeleton variant="rectangular" width="50%" sx={{ height: 'auto' }} />
                </Box>
            </div>

            <div className='preview-mobile' style={{ width: '100%', flexDirection: 'column' }}>
                <Box
                    sx={{
                        width: '100%',
                        bgcolor: 'background.paper',
                        borderRadius: 3,
                        boxShadow: 2,
                        p: 2,
                        border: '1px solid #e0e0e0',
                        overflow: 'hidden',
                    }}
                >
                    {/* Header: avatar + nombre + fecha */}
                    <Stack direction="row" spacing={2} alignItems="center" mb={2}>
                        <Skeleton variant="circular" width={48} height={48} sx={{ bgcolor: '#c0c0c0' }} />
                        <Box sx={{ flexGrow: 1 }}>
                            <Skeleton variant="text" width="60%" height={22} sx={{ borderRadius: 1, fontWeight: 'bold' }} />
                            <Skeleton variant="text" width="80%" height={18} sx={{ borderRadius: 1, mt: 0.5 }} />
                        </Box>
                    </Stack>

                    {/* Mensaje de texto */}
                    <Skeleton
                        variant="text"
                        width="100%"
                        height={60}
                        sx={{ borderRadius: 1, mb: 2 }}
                    />

                    {/* Imagen */}
                    <Skeleton
                        variant="rectangular"
                        width="100%"
                        height={180} // ratio aproximado 16:9 en un ancho de 320-360px
                        sx={{ borderRadius: 2, mb: 2 }}
                    />

                    {/* Barra inferior: iconos */}
                    <Stack direction="row" spacing={2} alignItems="center">
                        <Skeleton variant="circular" width={30} height={30} sx={{ bgcolor: '#c0c0c0' }} />
                        <Skeleton variant="circular" width={30} height={30} sx={{ bgcolor: '#c0c0c0' }} /> {/* verde whatsapp */}
                    </Stack>
                </Box>
                <br></br>
                <Box
                    sx={{
                        width: '100%',
                        bgcolor: 'background.paper',
                        borderRadius: 3,
                        boxShadow: 2,
                        p: 2,
                        border: '1px solid #e0e0e0',
                        overflow: 'hidden',
                    }}
                >
                    {/* Header: avatar + nombre + fecha */}
                    <Stack direction="row" spacing={2} alignItems="center" mb={2}>
                        <Skeleton variant="circular" width={48} height={48} sx={{ bgcolor: '#c0c0c0' }} />
                        <Box sx={{ flexGrow: 1 }}>
                            <Skeleton variant="text" width="60%" height={22} sx={{ borderRadius: 1, fontWeight: 'bold' }} />
                            <Skeleton variant="text" width="80%" height={18} sx={{ borderRadius: 1, mt: 0.5 }} />
                        </Box>
                    </Stack>

                    {/* Mensaje de texto */}
                    <Skeleton
                        variant="text"
                        width="100%"
                        height={60}
                        sx={{ borderRadius: 1, mb: 2 }}
                    />

                    {/* Imagen */}
                    <Skeleton
                        variant="rectangular"
                        width="100%"
                        height={180} // ratio aproximado 16:9 en un ancho de 320-360px
                        sx={{ borderRadius: 2, mb: 2 }}
                    />

                    {/* Barra inferior: iconos */}
                    <Stack direction="row" spacing={2} alignItems="center">
                        <Skeleton variant="circular" width={30} height={30} sx={{ bgcolor: '#c0c0c0' }} />
                        <Skeleton variant="circular" width={30} height={30} sx={{ bgcolor: '#c0c0c0' }} /> {/* verde whatsapp */}
                    </Stack>
                </Box>
                <br></br>
                <Box
                    sx={{
                        width: '100%',
                        bgcolor: 'background.paper',
                        borderRadius: 3,
                        boxShadow: 2,
                        p: 2,
                        border: '1px solid #e0e0e0',
                        overflow: 'hidden',
                    }}
                >
                    {/* Header: avatar + nombre + fecha */}
                    <Stack direction="row" spacing={2} alignItems="center" mb={2}>
                        <Skeleton variant="circular" width={48} height={48} sx={{ bgcolor: '#c0c0c0' }} />
                        <Box sx={{ flexGrow: 1 }}>
                            <Skeleton variant="text" width="60%" height={22} sx={{ borderRadius: 1, fontWeight: 'bold' }} />
                            <Skeleton variant="text" width="80%" height={18} sx={{ borderRadius: 1, mt: 0.5 }} />
                        </Box>
                    </Stack>

                    {/* Mensaje de texto */}
                    <Skeleton
                        variant="text"
                        width="100%"
                        height={60}
                        sx={{ borderRadius: 1, mb: 2 }}
                    />

                    {/* Imagen */}
                    <Skeleton
                        variant="rectangular"
                        width="100%"
                        height={180} // ratio aproximado 16:9 en un ancho de 320-360px
                        sx={{ borderRadius: 2, mb: 2 }}
                    />

                    {/* Barra inferior: iconos */}
                    <Stack direction="row" spacing={2} alignItems="center">
                        <Skeleton variant="circular" width={30} height={30} sx={{ bgcolor: '#c0c0c0' }} />
                        <Skeleton variant="circular" width={30} height={30} sx={{ bgcolor: '#c0c0c0' }} /> {/* verde whatsapp */}
                    </Stack>
                </Box>
            </div>
        </>
    )
}
